import { render, staticRenderFns } from "./PreenchimentoCensoPage.vue?vue&type=template&id=3c83aa77"
import script from "./PreenchimentoCensoPage.vue?vue&type=script&lang=js"
export * from "./PreenchimentoCensoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports